import React from 'react';
import { Contacts } from 'resources/js/personas/byron/header/Contacts';
import { SocialContactsTS } from 'resources/js/personas/shared/components/social-contacts/SocialContactsTS';
import { useStyles, StyleSheet } from '@rexlabs/styling';
import { HeaderSocials } from 'resources/js/personas/byron/header/HeaderBlock';

const desktopContactsDefaultStyles = StyleSheet({
  contactsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: 'auto',
    boxSizing: 'border-box',
    height: '20px',
    marginTop: '5px',
    marginBottom: '5px',
    '@media(max-width: 1440px)': {
      marginTop: '10px',
      marginBottom: '10px'
    }
  }
});

interface Props {
  enableContactDetails: boolean;
  transparentFontColor: string;
  contactDetailsFontColor?: string;
  menuFontColor: string;
  menuFontHoverColor: string;
  isTransparent: boolean;
  email: string;
  phone: string;
  socials: HeaderSocials;
}

export function DesktopContacts(props: Props) {
  const s = useStyles(desktopContactsDefaultStyles);
  return (
    <div {...s('contactsWrapper')}>
      <Contacts
        shouldDisplay={props.enableContactDetails}
        itemColor={
          props.isTransparent
            ? props.transparentFontColor
            : props.contactDetailsFontColor
        }
        email={props.email}
        phone={props.phone}
      />

      <SocialContactsTS
        socialLinks={props.socials}
        overrideColor={
          props.isTransparent ? props.transparentFontColor : props.menuFontColor
        }
        menuFontHoverColor={props.menuFontHoverColor}
      />
    </div>
  );
}
